export const apiConstants = {
  meals: '/meals',
};
